'use client';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Extend dayjs with timezone plugins
dayjs.extend(utc);
dayjs.extend(timezone);

export interface SafeDateProps {
  date: string;
  tz?: string; //  defaults to "Australia/Sydney"
  formatString?: string;
}

export function SafeDate({
  date,
  tz = 'Australia/Sydney',
  formatString = 'D MMM YYYY',
}: SafeDateProps) {
  return dayjs(date).tz(tz).format(formatString);
}
